import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import Process from "@/components/Process";
import Testimonials from "@/components/Testimonials";
import About from "@/components/About";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import LeadPopup from "@/components/LeadPopup";
import useReveal from "@/hooks/useReveal";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

// Admin pages are code-split — they only download when user visits /admin
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const BookingPage = lazy(() => import("@/pages/BookingPage"));
const QuotePage = lazy(() => import("@/pages/QuotePage"));

const AdminFallback = () => (
  <div className="min-h-screen grid place-items-center text-white/60">
    Laster admin…
  </div>
);

const Home = () => {
  useReveal();
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <Gallery />
      <Process />
      <Testimonials />
      <About />
      <FAQ />
      <Contact />
      <Footer />
      <LeadPopup />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/bestill"
              element={
                <Suspense fallback={<AdminFallback />}>
                  <BookingPage />
                </Suspense>
              }
            />
            <Route
              path="/tilbud/:token"
              element={
                <Suspense fallback={<AdminFallback />}>
                  <QuotePage />
                </Suspense>
              }
            />
            <Route
              path="/admin/login"
              element={
                <Suspense fallback={<AdminFallback />}>
                  <AdminLogin />
                </Suspense>
              }
            />
            <Route
              path="/admin"
              element={
                <Suspense fallback={<AdminFallback />}>
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                </Suspense>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
